import React from "react";
import assets from "../../../shared/constants/assetVariables";

function Section_10() {
  return (
    <section className="csrd-landing-page-section-10-container">
      <div className="csrd-landing-page-section-10-inner-container">
        <div
          className="section-10-left-container"
          data-aos="slide-right"
          data-aos-delay="100"
          data-aos-duration="1000"
          data-aos-once="true">
          <div className="section-10-left-header">CSRD Made Simple</div>
          <div className="section-10-left-sub-header">
            Get expert guidance for your reporting needs
          </div>
          <div className="section-10-left-button-container">
            <button className="section-10-left-button">
              Get Expert Guidance <img src={assets.icons.rightArrowIconWhite} />
            </button>
          </div>
        </div>
        <div
          className="section-10-right-container"
          data-aos="fade-left"
          data-aos-delay="100"
          data-aos-duration="1500"
          data-aos-once="true">
          <img src={assets.images.section10Imag} alt="section-10-img" className="section_10_img" />
        </div>
      </div>
    </section>
  );
}

export default Section_10;
